module.exports = __webpack_public_path__ + "img/img-flow-2-2.ca3f3259.png";